
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  toStart: {
    id: "Troughs.toStart",
    defaultMessage: "To start the configuration, you must {login}. If you do not yet have an account, {create}.",
  },
  toStartLogin: {
    id: "Troughs.toStartLogin",
    defaultMessage: "log in",
  },
  toStartCreate: {
    id: "Troughs.toStartCreate",
    defaultMessage: "create a new account",
  },
});

export default MESSAGES;